export default {"src":"/_next/static/media/omnichannel-icon.0265487f.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};